module.exports = require("morgan");


/*****************
 ** WEBPACK FOOTER
 ** external "morgan"
 ** module id = 7
 ** module chunks = 0
 **/